<template>
  <div id="news">
    <Pheader></Pheader>
    <div class="banner"></div>
    <div class="content">
      <div class="channel-wrap">
        <div @click="choseChannel(index)" :class="['channel-item', activeChannel == index ? 'active' : '']" v-for="(item, index) in channelList" :key="index">{{item.name}}</div>
      </div>
      <div @click="jumpDetail(item.id)" class="news-section" v-for="(item, index) in news" :key="index">
        <div class="news-title">{{item.title}}</div>
        <div class="news-date">{{item.publish_time}}</div>
      </div>
      <div class="page-box">
        <div class="left" @click="chagePage(-1)">&lt;</div>
        <div class="page">{{page}}/{{total}}</div>
        <div class="right" @click="chagePage(1)">&gt;</div>
      </div>
    </div>
    <Pbottom></Pbottom>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { abort, newsList } from "@/proxy/index"
import Pheader from "@/components/pc/Head";
import Pbottom from "@/components/pc/Bottom1";
export default {
  components: {
    Pheader,
    Pbottom
  },
  computed: {
    ...mapState(["_myData", "_channelId"]),
  },
  watch: {
    _myData: {
      handler (n, o) {
        if (n.news && !this._channelId) {
          this.$store.dispatch('setChannelId', n.news[0].id)
        }
      },
      immediate: true
    },
    _channelId: {
      handler (n, o) {
        if (n) {
          this.getData(n)
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      news: [],
      channelList: [],
      activeChannel: 0,
      total: 1,
      page: 1
    }
  },
  created () {
    window.scrollTo({
      top: 0,
    });
  },
  methods: {
    getData (id) {
      newsList(id, this.page).then(res => {
        if (res.data.code == 0) {
          const data = res.data.data
          this.channelList = data.channel
          this.activeChannel = this.channelList.findIndex(i => i.id == id)
          this.news = data.data.list
          this.total = Math.ceil(data.data.total_count/10) || 1
        }
      })
    },
    chagePage (num) {
      if (num == -1 && this.page == 1) {
        return false
      }
      if (num == 1 && this.page == this.total) {
        return false
      }
      this.page += num
      abort()
      this.getData(this._channelId)
    },
    choseChannel (index) {
      this.activeChannel = index
      this.page = 1
      abort()
      this.$store.dispatch('setChannelId', this.channelList[index].id)
    },
    jumpDetail (id) {
      this.$router.push({name: 'detail', query: {id}})
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/views/news.scss";
</style>
